import { Inject, Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Message } from "primeng/components/common/api";
import { DOCUMENT } from "@angular/platform-browser";
@Injectable()
export class NgToastrService {
    private static instance: NgToastrService = null;

    private messages: Message[]; // It has to be array for supporting growl input
    private messageObserver: Subject<Message[]> = new Subject<Message[]>();

    // Component observer for multiline identification
    private lastMessageObserver: Subject<Message> = new Subject<Message>();
    private lifeObserver: Subject<number> = new Subject<number>();
    private life = 3500; // Time for the element to be displayed

    public static getInstance(document: Document) {
        if (!NgToastrService.instance) {
            NgToastrService.instance = new NgToastrService(document);
        }
        return NgToastrService.instance;
    }

    private constructor(@Inject(DOCUMENT) private document: Document) { }

    public getLife() {
        return this.life;
    }

    public setLife(life?: number) {
        this.lifeObserver.next(life || this.life);
    }

    public add(message: Message): void {
        if (message) {
            this.messages = [message];
            this.lastMessageObserver.next(message);
            this.update();
        }
        this.setLife();
    }

    public clear(): void {
        this.messages = [];
        this.update();
    }

    public error(summary: string, detail?: string): NgToastrService {
        detail = detail ? this.saveHtml(detail) : "";
        this.add({
            severity: "error",
            summary,
            detail
        });
        return this;
    }

    public getMessage(): Message[] {
        return this.messages;
    }

    public info(summary: string, detail?: string): NgToastrService {
        detail = detail ? this.saveHtml(detail) : "";
        this.add({
            severity: "info",
            summary,
            detail
        });
        return this;
    }

    public subscribe(observer): void {
        this.messageObserver.subscribe(observer);
    }

    public success(summary: string, detail?: string): NgToastrService {
        detail = detail ? this.saveHtml(detail) : "";
        this.add({
            severity: "success",
            summary,
            detail
        });
        return this;
    }

    public warn(summary: string, detail?: string): NgToastrService {
        detail = detail ? this.saveHtml(detail) : "";
        this.add({
            severity: "warn",
            summary,
            detail,
        });
        return this;
    }

    private update(): void {
        this.messageObserver.next(this.messages);
    }

    private saveHtml(value): string {
        const dom = this.document.createElement("div");
        dom.append(this.document.createTextNode(value));
        return dom.innerHTML;
    }

    getObserverSubject(): Subject<Message> {
        return this.lastMessageObserver;
    }

    getLifeObserverSubject(): Subject<number> {
        return this.lifeObserver;

    }
}
